<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <br />
    <b-button variant="primary" v-if="loading" disabled>
      <b-spinner small></b-spinner>
      Cargando...
    </b-button>

    <div class="mt-2 col-md-12"></div>
    <p
      v-show="hojasCDX.length == 0 && loading == false"
      class="mginTop15 boldBlue size22"
    >
      No se encontraron hojas de diagnóstico para el paciente.
    </p>

    <div
      v-show="hojasCDX.length != 0"
      class="hojasCDX"
      v-if="$localStorageService.can('HX_01_Hx_detalle')"
    >
      <div
        v-for="item in hojasCDX"
        :key="item.idSesion"
        :value="item.nombreClinica"
      >
        <div class="divHojas">
          <b-button
            :class="item.visible ? null : 'collapsed'"
            :aria-expanded="item.visible ? 'true' : 'false'"
            @click="item.visible = !item.visible"
            id="text-button"
            variant="primary"
          >
            <div class="flxHoja">
              <div class="flxItmHojaPr">
                <b-icon icon="caret-up-fill" v-if="item.visible"></b-icon>
                <b-icon icon="caret-down-fill" v-else></b-icon>
                - Id. {{ item.idPti }} - {{ item.clinica }} - {{ item.fecha }} -
                HOJA <span v-if="item.denticion == 1"> NIÑO </span>
                <span v-else-if="item.denticion == 2"> ADULTO </span>
                <span v-else> MIXTO </span>
                <span v-if="item.tipoPti != '-'"> | {{ item.tipoPti }} </span>

                <b-badge v-if="item.registroActivo" variant="success"
                  >ACTIVO</b-badge
                >
                <b-badge v-else variant="danger">INACTIVO</b-badge>
              </div>

              <div class="flxItmHojaSc">
                <b-button
                  :disabled="!item.ptiFueraCDX"
                  @click="abrirDetallePti(item)"
                  id="text-button"
                  variant="info"
                >
                  <font-awesome-icon
                    v-if="item.ptiFueraCDX"
                    icon="edit"
                    v-b-popover.hover.top="'EDITAR PTI'"
                  />
                  <span
                    v-else
                    v-b-popover.hover.top="'EL PTI no se puede editar'"
                  >
                    -
                  </span>
                </b-button>
              </div>
            </div>
          </b-button>

          <b-collapse v-model="item.visible" class="mt-2">
            <!-- nino -->
            <div v-if="item.denticion == 1">
              <div class="col-12">
                <br />
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-4" align="left">
                      <label class="letraEstiloNegrita"
                        >Fecha de la solicitud</label
                      >
                      <b-input
                        v-model="item.fecha"
                        disabled
                        size="sm"
                      ></b-input>
                    </div>

                    <div class="col-4" align="left">
                      <label class="letraEstiloNegrita">Clínica</label>
                      <b-input v-model="item.clinica" disabled> </b-input>
                    </div>

                    <div class="col-4" align="left">
                      <label class="letraEstiloNegrita">Og</label>
                      <br />
                      <b-input v-model="item.doctor" disabled> </b-input>
                    </div>
                  </div>
                </div>

                <div class="container-fluid">
                  <br />
                  <div class="row">
                    <div class="col-8" align="left">
                      <label s class="letraEstiloNegrita"
                        >Enfermedad sistémica</label
                      >
                      <b-input
                        v-model="item.enfermedadSistemica"
                        placeholder="Introduzca enfermedad sistémica"
                        disabled
                      >
                        ></b-input
                      >
                    </div>

                    <div class="col-4">
                      <br />
                      <b-form-checkbox
                        class="letraEstiloNegrita"
                        v-model="item.candidatoOrtodoncia"
                        disabled
                        name="check-button"
                        switch
                      >
                        Candidato ortodoncia/ortopedia
                      </b-form-checkbox>
                    </div>
                  </div>
                </div>

                <div class="container-fluid">
                  <br />
                  <div class="row">
                    <div class="col-12">
                      <span class="input-group-text">
                        <span class="letraEstiloNegrita"
                          >Alineación del paciente (motivo de consulta,
                          información relevante sobre tu paciente -medicamentos,
                          expectativas- , tratamientos realizados
                          recientemente)</span
                        >
                      </span>
                      <textarea
                        class="form-control"
                        aria-label="With textarea"
                        v-model="item.alineacionPaciente"
                        disabled
                      ></textarea>
                      <br />
                    </div>
                  </div>
                  <br />
                </div>
                <!---Dx ortodoncia--->

                <div>
                  <md-toolbar class="subtitulos">
                    <h3>Diagnóstico Ortopedia</h3>
                  </md-toolbar>
                </div>
                <br />
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-3">Apiñamiento</div>
                    <div class="col-3">
                      <div class="row">
                        <span>
                          <b-form-radio-group
                            id="radio-group-20"
                            v-model="item.apinamiento"
                            :options="apinamientos"
                            name="radio-options-apinamiento"
                            disabled
                          ></b-form-radio-group>
                        </span>
                        <br />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-3">Mordida Cruzada</div>
                    <b-form-radio-group
                      id="radio-group-25"
                      v-model="item.mordidaCruzada"
                      :options="mordidascruzada"
                      name="radio-options-mordidaCruzada"
                      disabled
                    ></b-form-radio-group>
                  </div>

                  <div class="row">
                    <div class="col-3">Mordida Abierta</div>
                    <b-form-radio-group
                      id="radio-group-26"
                      v-model="item.mordidaAbierta"
                      :options="mordidasabierta"
                      name="radio-options-mordidaAbierta"
                      disabled
                    ></b-form-radio-group>
                  </div>

                  <div class="row">
                    <div class="col-3">Mordida borde a borde</div>
                    <b-form-radio-group
                      id="radio-group-27"
                      v-model="item.mordidaBorde"
                      :options="mordidasbordeborde"
                      name="radio-options-mordidabordeborde"
                      disabled
                    ></b-form-radio-group>
                  </div>

                  <div class="row">
                    <div class="col-3">Factores estéticos</div>
                    <b-form-radio-group
                      id="radio-group-28"
                      v-model="item.factorEstetico"
                      :options="factoresteticos"
                      name="radio-options-factoresteticos"
                      disabled
                    ></b-form-radio-group>
                  </div>

                  <div class="row">
                    <div class="col-3">
                      Aplica únicamente en niño
                      <br />
                      Padecimientos de crecimiento y desarrollo
                    </div>
                    <b-form-radio-group
                      id="radio-group-23"
                      v-model="item.desarrollo"
                      :options="padecimientosdesarrollo"
                      name="radio-options-padecimientoDesarrollo"
                      disabled
                    ></b-form-radio-group>
                  </div>

                  <br />
                </div>
                <!--del container fluid-->
                <!---Bruxismo y Limpieza----->
                <div>
                  <md-toolbar class="subtitulos">
                    <!-- <h3>IPB</h3> -->
                  </md-toolbar>
                </div>

                <div class="container-fluid">
                  <br />
                  <div class="row"></div>
                  <div class="row">
                    <div class="col-3">Placa/Sarro</div>
                    <div class="col-3">
                      <b-form-radio-group
                        id="radio-group-41"
                        v-model="item.placaSarro"
                        :options="placasarros"
                        name="radio-options-placasarro"
                        disabled
                      ></b-form-radio-group>
                    </div>
                  </div>
                </div>
                <br />

                <div>
                  <md-toolbar class="subtitulos">
                    <h3>Dentición infantil</h3>
                  </md-toolbar>
                </div>
                <div class="container-fluid">
                  <div class="row">
                    <div class="container-fluid">
                      <div class="row">
                        <b-table-simple>
                          <b-thead class="columnas">
                            <b-tr>
                              <b-th> OD </b-th>
                              <b-th> Hallazgos Clínicos </b-th>
                            </b-tr>
                          </b-thead>
                          <b-tbody>
                            <b-tr
                              v-for="data of item.dientesNino"
                              v-bind:key="data.idDiente"
                            >
                              <b-td>
                                {{ data.numeroDiente }}
                              </b-td>
                              <b-td>
                                <span v-if="data.lstPadecimientos.length != 0">
                                  <div
                                    v-for="(
                                      data, index
                                    ) of data.lstPadecimientos"
                                    v-bind:key="index"
                                  >
                                    <b-input
                                      v-model="data.nombrePdx"
                                      placeholder="Padecimiento"
                                      disabled
                                    >
                                      ></b-input
                                    >
                                    <br />
                                  </div>
                                </span>
                                <div v-else style="text-align: left">
                                  <b-input
                                    placeholder="Sin padecimiento"
                                    disabled
                                  >
                                    ></b-input
                                  >
                                </div>
                              </b-td>
                            </b-tr>
                          </b-tbody>
                        </b-table-simple>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="item.denticion == 2">
              <div class="col-12">
                <br />
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-4" align="left">
                      <label class="letraEstiloNegrita"
                        >Fecha de la solicitud</label
                      >
                      <b-input
                        v-model="item.fecha"
                        disabled
                        size="sm"
                      ></b-input>
                    </div>

                    <div class="col-4" align="left">
                      <label class="letraEstiloNegrita">Clínica</label>
                      <b-input v-model="item.clinica" disabled> </b-input>
                    </div>

                    <div class="col-4" align="left">
                      <label class="letraEstiloNegrita">Og</label>
                      <br />
                      <b-input v-model="item.doctor" disabled> </b-input>
                    </div>
                  </div>
                </div>

                <div class="container-fluid">
                  <br />
                  <div class="row">
                    <div class="col-8" align="left">
                      <label s class="letraEstiloNegrita"
                        >Enfermedad sistémica</label
                      >
                      <b-input
                        v-model="item.enfermedadSistemica"
                        placeholder="Introduzca enfermedad sistémica"
                        disabled
                      >
                        ></b-input
                      >
                    </div>

                    <div class="col-4">
                      <br />
                      <b-form-checkbox
                        class="letraEstiloNegrita"
                        v-model="item.candidatoOrtodoncia"
                        disabled
                        name="check-button"
                        switch
                      >
                        Candidato ortodoncia/ortopedia
                      </b-form-checkbox>
                    </div>
                  </div>
                </div>

                <div class="container-fluid">
                  <br />
                  <div class="row">
                    <div class="col-12">
                      <span class="input-group-text">
                        <span class="letraEstiloNegrita"
                          >Alineación del paciente (motivo de consulta,
                          información relevante sobre tu paciente -medicamentos,
                          expectativas- , tratamientos realizados
                          recientemente)</span
                        >
                      </span>
                      <textarea
                        class="form-control"
                        aria-label="With textarea"
                        v-model="item.alineacionPaciente"
                        disabled
                      ></textarea>
                      <br />
                    </div>
                  </div>
                  <br />
                </div>
                <!---Dx ortodoncia--->

                <div>
                  <md-toolbar class="subtitulos">
                    <h3>Diagnóstico Ortodoncia</h3>
                  </md-toolbar>
                </div>
                <br />
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-3">Apiñamiento</div>
                    <div class="col-3">
                      <div class="row">
                        <span>
                          <b-form-radio-group
                            id="radio-group-20"
                            v-model="item.apinamiento"
                            :options="apinamientos"
                            name="radio-options-apinamiento"
                            disabled
                          ></b-form-radio-group>
                        </span>
                        <br />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-3">Clase molar derecha</div>
                    <b-form-radio-group
                      id="radio-group-1"
                      v-model="item.claseMolarDerecha"
                      :options="clasesmolarderecha"
                      disabled
                      name="radio-options-clasemolarderecha"
                    ></b-form-radio-group>
                  </div>
                  <div class="row">
                    <div class="col-3">Clase molar izquierda</div>
                    <b-form-radio-group
                      id="radio-group-2"
                      v-model="item.claseMolarIzquierda"
                      :options="clasesmolarizquierda"
                      disabled
                      name="radio-options-clasemolarizquierda"
                    ></b-form-radio-group>
                  </div>
                  <div class="row">
                    <div class="col-3">Clase canina izquierda</div>
                    <b-form-radio-group
                      id="radio-group-3"
                      v-model="item.claseCaninaIzquierda"
                      :options="clasescaninaizquierda"
                      disabled
                      name="radio-options-clasecaninaizquierda"
                    ></b-form-radio-group>
                  </div>
                  <div class="row">
                    <div class="col-3">Clase canina derecha</div>
                    <b-form-radio-group
                      id="radio-group-4"
                      v-model="item.claseCaninaDerecha"
                      :options="clasescaninaderecha"
                      disabled
                      name="radio-options-clasecaninaderecha"
                    ></b-form-radio-group>
                  </div>

                  <div class="row">
                    <div class="col-3">Mordida Cruzada</div>
                    <b-form-radio-group
                      id="radio-group-25"
                      v-model="item.mordidaCruzada"
                      :options="mordidascruzada"
                      name="radio-options-mordidaCruzada"
                      disabled
                    ></b-form-radio-group>
                  </div>

                  <div class="row">
                    <div class="col-3">Mordida Abierta</div>
                    <b-form-radio-group
                      id="radio-group-26"
                      v-model="item.mordidaAbierta"
                      :options="mordidasabierta"
                      name="radio-options-mordidaAbierta"
                      disabled
                    ></b-form-radio-group>
                  </div>

                  <div class="row">
                    <div class="col-3">Mordida borde a borde</div>
                    <b-form-radio-group
                      id="radio-group-27"
                      v-model="item.mordidaBorde"
                      :options="mordidasbordeborde"
                      name="radio-options-mordidabordeborde"
                      disabled
                    ></b-form-radio-group>
                  </div>

                  <div class="row">
                    <div class="col-3">Factores estéticos</div>
                    <b-form-radio-group
                      id="radio-group-28"
                      v-model="item.factorEstetico"
                      :options="factoresteticos"
                      name="radio-options-factoresteticos"
                      disabled
                    ></b-form-radio-group>
                  </div>

                  <br />
                </div>
                <!--del container fluid-->
                <!---Bruxismo y Limpieza----->
                <div>
                  <md-toolbar class="subtitulos">
                    <!-- <h3>IPB</h3> -->
                  </md-toolbar>
                </div>

                <div class="container-fluid">
                  <br />
                  <div class="row"></div>
                  <div class="row">
                    <div class="col-3">Bruxismo</div>
                    <div class="col-3">
                      <b-form-radio-group
                        id="radio-group-10"
                        v-model="item.bruxismo"
                        :options="bruxismos"
                        name="radio-options-bruxismo"
                        disabled
                      ></b-form-radio-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-3">Placa/Sarro</div>
                    <div class="col-3">
                      <b-form-radio-group
                        id="radio-group-41"
                        v-model="item.placaSarro"
                        :options="placasarros"
                        name="radio-options-placasarro"
                        disabled
                      ></b-form-radio-group>
                    </div>
                  </div>
                </div>
                <br />

                <div>
                  <md-toolbar class="subtitulos">
                    <h3>Periodontitis</h3>
                  </md-toolbar>
                </div>
                <div class="container-fluid">
                  <br />

                  <div class="row">
                    <div class="col-4">Superior</div>

                    <div class="col-4">
                      <b-form-checkbox v-model="item.raspadoSuperior1" disabled
                        >I</b-form-checkbox
                      >
                    </div>

                    <div class="col-4">
                      <b-form-checkbox v-model="item.raspadoSuperior2" disabled
                        >II</b-form-checkbox
                      >
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-4">Inferior</div>

                    <div class="col-4">
                      <b-form-checkbox v-model="item.raspadoInferior1" disabled
                        >III</b-form-checkbox
                      >
                    </div>

                    <div class="col-4">
                      <b-form-checkbox v-model="item.raspadoInferior2" disabled
                        >IV</b-form-checkbox
                      >
                    </div>
                  </div>
                  <br />
                </div>

                <div>
                  <md-toolbar class="subtitulos">
                    <h3>Dentición Adulta</h3>
                  </md-toolbar>
                </div>
                <div class="container-fluid">
                  <div class="row">
                    <div class="container-fluid">
                      <div class="row">
                        <b-table-simple>
                          <b-thead class="columnas">
                            <b-tr>
                              <b-th> OD </b-th>
                              <b-th> Hallazgos Clínicos </b-th>
                            </b-tr>
                          </b-thead>
                          <b-tbody>
                            <b-tr
                              v-for="data of item.dientesAdulto"
                              v-bind:key="data.idDiente"
                            >
                              <b-td>
                                {{ data.numeroDiente }}
                              </b-td>
                              <b-td>
                                <span v-if="data.lstPadecimientos.length != 0">
                                  <div
                                    v-for="(
                                      data, index
                                    ) of data.lstPadecimientos"
                                    v-bind:key="index"
                                  >
                                    <b-input
                                      v-model="data.nombrePdx"
                                      placeholder="Padecimiento"
                                      disabled
                                    >
                                      ></b-input
                                    >
                                    <br />
                                  </div>
                                </span>
                                <div v-else style="text-align: left">
                                  <b-input
                                    placeholder="Sin padecimiento"
                                    disabled
                                  >
                                    ></b-input
                                  >
                                </div>
                              </b-td>
                            </b-tr>
                          </b-tbody>
                        </b-table-simple>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="item.denticion == 3">
              <div class="col-12">
                <br />
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-4" align="left">
                      <label class="letraEstiloNegrita"
                        >Fecha de la solicitud</label
                      >
                      <b-input
                        v-model="item.fecha"
                        disabled
                        size="sm"
                      ></b-input>
                    </div>

                    <div class="col-4" align="left">
                      <label class="letraEstiloNegrita">Clínica</label>
                      <b-input v-model="item.clinica" disabled> </b-input>
                    </div>

                    <div class="col-4" align="left">
                      <label class="letraEstiloNegrita">Og</label>
                      <br />
                      <b-input v-model="item.doctor" disabled> </b-input>
                    </div>
                  </div>
                </div>

                <div class="container-fluid">
                  <br />
                  <div class="row">
                    <div class="col-8" align="left">
                      <label s class="letraEstiloNegrita"
                        >Enfermedad sistémica</label
                      >
                      <b-input
                        v-model="item.enfermedadSistemica"
                        placeholder="Introduzca enfermedad sistémica"
                        disabled
                      >
                        ></b-input
                      >
                    </div>

                    <div class="col-4">
                      <br />
                      <b-form-checkbox
                        class="letraEstiloNegrita"
                        v-model="item.candidatoOrtodoncia"
                        disabled
                        name="check-button"
                        switch
                      >
                        Candidato ortodoncia/ortopedia
                      </b-form-checkbox>
                    </div>
                  </div>
                </div>

                <div class="container-fluid">
                  <br />
                  <div class="row">
                    <div class="col-12">
                      <span class="input-group-text">
                        <span class="letraEstiloNegrita"
                          >Alineación del paciente (motivo de consulta,
                          información relevante sobre tu paciente -medicamentos,
                          expectativas- , tratamientos realizados
                          recientemente)</span
                        >
                      </span>
                      <textarea
                        class="form-control"
                        aria-label="With textarea"
                        v-model="item.alineacionPaciente"
                        disabled
                      ></textarea>
                      <br />
                    </div>
                  </div>
                  <br />
                </div>
                <!---Dx ortodoncia--->

                <!---Diagnóstico Ortodoncia--->
                <div>
                  <md-toolbar class="subtitulos">
                    <h3>Diagnóstico Ortodoncia</h3>
                  </md-toolbar>
                </div>
                <div class="container-fluid">
                  <br />

                  <div class="row">
                    <div class="col-3">Clase molar derecha</div>
                    <b-form-radio-group
                      id="radio-group-81"
                      v-model="item.claseMolarDerecha"
                      :options="clasesmolarderecha"
                      disabled
                      name="radio-options-clasemolarderecha"
                    ></b-form-radio-group>
                  </div>
                  <div class="row">
                    <div class="col-3">Clase molar izquierda</div>
                    <b-form-radio-group
                      id="radio-group-42"
                      v-model="item.claseMolarIzquierda"
                      :options="clasesmolarizquierda"
                      disabled
                      name="radio-options-clasemolarizquierda"
                    ></b-form-radio-group>
                  </div>
                  <div class="row">
                    <div class="col-3">Clase canina izquierda</div>
                    <b-form-radio-group
                      id="radio-group-43"
                      v-model="item.claseCaninaIzquierda"
                      :options="clasescaninaizquierda"
                      disabled
                      name="radio-options-clasecaninaizquierda"
                    ></b-form-radio-group>
                  </div>
                  <div class="row">
                    <div class="col-3">Clase canina derecha</div>
                    <b-form-radio-group
                      id="radio-group-44"
                      v-model="item.claseCaninaDerecha"
                      :options="clasescaninaderecha"
                      disabled
                      name="radio-options-clasecaninaderecha"
                    ></b-form-radio-group>
                  </div>

                  <br />
                </div>

                <div>
                  <md-toolbar class="subtitulos">
                    <h3>Diagnóstico Ortopedia</h3>
                  </md-toolbar>
                </div>
                <br />
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-3">Apiñamiento</div>
                    <div class="col-3">
                      <div class="row">
                        <span>
                          <b-form-radio-group
                            id="radio-group-20"
                            v-model="item.apinamiento"
                            :options="apinamientos"
                            name="radio-options-apinamiento"
                            disabled
                          ></b-form-radio-group>
                        </span>
                        <br />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-3">Mordida Cruzada</div>
                    <b-form-radio-group
                      id="radio-group-25"
                      v-model="item.mordidaCruzada"
                      :options="mordidascruzada"
                      name="radio-options-mordidaCruzada"
                      disabled
                    ></b-form-radio-group>
                  </div>

                  <div class="row">
                    <div class="col-3">Mordida Abierta</div>
                    <b-form-radio-group
                      id="radio-group-26"
                      v-model="item.mordidaAbierta"
                      :options="mordidasabierta"
                      name="radio-options-mordidaAbierta"
                      disabled
                    ></b-form-radio-group>
                  </div>

                  <div class="row">
                    <div class="col-3">Mordida borde a borde</div>
                    <b-form-radio-group
                      id="radio-group-27"
                      v-model="item.mordidaBorde"
                      :options="mordidasbordeborde"
                      name="radio-options-mordidabordeborde"
                      disabled
                    ></b-form-radio-group>
                  </div>

                  <div class="row">
                    <div class="col-3">Factores estéticos</div>
                    <b-form-radio-group
                      id="radio-group-28"
                      v-model="item.factorEstetico"
                      :options="factoresteticos"
                      name="radio-options-factoresteticos"
                      disabled
                    ></b-form-radio-group>
                  </div>

                  <div class="row">
                    <div class="col-3">
                      Aplica únicamente en niño
                      <br />
                      Padecimientos de crecimiento y desarrollo
                    </div>
                    <b-form-radio-group
                      id="radio-group-23"
                      v-model="item.desarrollo"
                      :options="padecimientosdesarrollo"
                      name="radio-options-padecimientoDesarrollo"
                      disabled
                    ></b-form-radio-group>
                  </div>

                  <br />
                </div>
                <!--del container fluid-->
                <!---Bruxismo y Limpieza----->
                <div>
                  <md-toolbar class="subtitulos">
                    <!-- <h3>IPB</h3> -->
                  </md-toolbar>
                </div>

                <div class="container-fluid">
                  <br />
                  <div class="row"></div>
                  <div class="row">
                    <div class="col-3">Bruxismo</div>
                    <div class="col-3">
                      <b-form-radio-group
                        id="radio-group-10"
                        v-model="item.bruxismo"
                        :options="bruxismos"
                        name="radio-options-bruxismo"
                        disabled
                      ></b-form-radio-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-3">Placa/Sarro</div>
                    <div class="col-3">
                      <b-form-radio-group
                        id="radio-group-41"
                        v-model="item.placaSarro"
                        :options="placasarros"
                        name="radio-options-placasarro"
                        disabled
                      ></b-form-radio-group>
                    </div>
                  </div>
                </div>
                <br />

                <div>
                  <md-toolbar class="subtitulos">
                    <h3>Periodontitis</h3>
                  </md-toolbar>
                </div>
                <div class="container-fluid">
                  <br />

                  <div class="row">
                    <div class="col-4">Superior</div>

                    <div class="col-4">
                      <b-form-checkbox v-model="item.raspadoSuperior1" disabled
                        >I</b-form-checkbox
                      >
                    </div>

                    <div class="col-4">
                      <b-form-checkbox v-model="item.raspadoSuperior2" disabled
                        >II</b-form-checkbox
                      >
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-4">Inferior</div>

                    <div class="col-4">
                      <b-form-checkbox v-model="item.raspadoInferior1" disabled
                        >III</b-form-checkbox
                      >
                    </div>

                    <div class="col-4">
                      <b-form-checkbox v-model="item.raspadoInferior2" disabled
                        >IV</b-form-checkbox
                      >
                    </div>
                  </div>
                  <br />
                </div>

                <div>
                  <md-toolbar class="subtitulos">
                    <h3>DENTICIÓN MIXTA</h3>
                  </md-toolbar>
                </div>
                <div class="container-fluid">
                  <div class="row">
                    <div class="container-fluid">
                      <div class="row">
                        <b-table-simple>
                          <b-thead class="columnas">
                            <b-tr>
                              <b-th> OD </b-th>
                              <b-th> Hallazgos Clínicos </b-th>
                            </b-tr>
                          </b-thead>
                          <b-tbody>
                            <b-tr
                              v-for="data of item.dientesMixto"
                              v-bind:key="data.idDiente"
                            >
                              <b-td>
                                {{ data.numeroDiente }}
                              </b-td>
                              <b-td>
                                <span v-if="data.lstPadecimientos.length != 0">
                                  <div
                                    v-for="(
                                      data, index
                                    ) of data.lstPadecimientos"
                                    v-bind:key="index"
                                  >
                                    <b-input
                                      v-model="data.nombrePdx"
                                      placeholder="Padecimiento"
                                      disabled
                                    >
                                      ></b-input
                                    >
                                    <br />
                                  </div>
                                </span>
                                <div v-else style="text-align: left">
                                  <b-input
                                    placeholder="Sin padecimiento"
                                    disabled
                                  >
                                    ></b-input
                                  >
                                </div>
                              </b-td>
                            </b-tr>
                          </b-tbody>
                        </b-table-simple>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-collapse>
        </div>
      </div>
    </div>
    <br />
    <br />
  </div>
</template>
<script>
import moment from "moment";

export default {
  name: "hojasCDX",
  components: {},
  props: {
    idPaciente: {
      type: Number,
      required: true,
    },
    padecimientosNino: Array,
    padecimientosAdulto: Array,
    padecimientosMixto: Array,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    hojasCDX: [],
    loading: true,
    apinamientos: [{ text: "", value: 1 }],
    mordidascruzada: [
      { text: "Anterior", value: 1 },
      { text: "Posterior", value: 2 },
    ],
    mordidasabierta: [
      { text: "Anterior", value: 1 },
      { text: "Posterior", value: 2 },
    ],
    mordidasbordeborde: [{ text: "", value: 1 }],
    factoresteticos: [{ text: "", value: 1 }],
    padecimientosdesarrollo: [{ text: "", value: true }],
    placasarros: [{ text: "", value: true }],
    clasesmolarderecha: [
      { text: "I", value: 1 },
      { text: "II", value: 2 },
      { text: "III", value: 3 },
    ],
    clasesmolarizquierda: [
      { text: "I", value: 1 },
      { text: "II", value: 2 },
      { text: "III", value: 3 },
    ],
    clasescaninaizquierda: [
      { text: "I", value: 1 },
      { text: "II", value: 2 },
      { text: "III", value: 3 },
    ],
    clasescaninaderecha: [
      { text: "I", value: 1 },
      { text: "II", value: 2 },
      { text: "III", value: 3 },
    ],
    bruxismos: [{ text: "", value: true }],

    dientesNino: [],
    dientesAdulto: [],
    dientesMixto: [],
  }),
  beforeMount() {
    this.getDientes("dientesAdulto");
    this.getDientes("dientesNino");
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    // this.getHojasCDX();
  },
  methods: {
    abrirDetallePti(item) {
      if(item.ptiFueraCDX === true){
        this.$router.push({
          name: "PtiPresuntivoSinSDI",
          params: { id: item.idPti },
        });
      }else{
        this.$router.push({
          name: "PtiPresuntivo",
          params: { id: item.idPti },
        });
      }

    },
    getDientes(tipo) {
      var url = "ptipresuntivo/obtener/catalogo/dientes";
      const params = {
        adulto: tipo == "dientesAdulto" ? true : false, 
        ninio: tipo == "dientesAdulto" ? false : true,
      }

      this.$http
        .post(this.$api + url, params)
        .then((response) => {
          if (Array.isArray(response.data.data) == true) {
            response.data.data.forEach((element) => {
              if (element.numeroDiente != null) {
                this[tipo].push({
                  idDiente: element.idDiente,
                  nombreDiente: element.nombre,
                  numeroDiente: element.numeroDiente,
                  lstPadecimientos: [],
                });
              }
            });

            this.dientesMixto = JSON.parse(
              JSON.stringify(this.dientesAdulto.concat(this.dientesNino))
            );
          }
        })
        .catch(function (error) {
          console.error(error);
        })
        .finally(() => {
          this.getHojasCDX();
        });
    },
    getHojasCDX() {
      const parametros = {idPaciente: this.idPaciente}
      this.$http
        .post(
          this.$api +
            "diagnostico/hoja/obtenerHojasCDX", parametros
        )
        .then((response) => {
          var datos = JSON.parse(JSON.stringify(response.data.data));

          if (Array.isArray(datos)) {
            datos.forEach((element) => {
              element.fecha = moment(element.fecha).format("DD/MM/YYYY");
              element.dientesNino = JSON.parse(
                JSON.stringify(this.dientesNino)
              );

              element.dientesAdulto = JSON.parse(
                JSON.stringify(this.dientesAdulto)
              );
              element.dientesMixto = JSON.parse(
                JSON.stringify(this.dientesMixto)
              );

              if (Array.isArray(element.padecimientos)) {
                element.padecimientos.forEach((elementD) => {
                  if (element.denticion == 1) {
                    element.dientesNino.forEach((elementT) => {
                      if (elementD.idDiente == elementT.idDiente) {
                        elementT.lstPadecimientos.push({
                          nombrePdx: elementD.nombrePdx,
                        });
                      }
                    });
                  } else if (element.denticion == 2) {
                    element.dientesAdulto.forEach((elementT) => {
                      if (elementD.idDiente == elementT.idDiente) {
                        elementT.lstPadecimientos.push({
                          nombrePdx: elementD.nombrePdx,
                        });
                      }
                    });
                  } else {
                    element.dientesMixto.forEach((elementT) => {
                      if (elementD.idDiente == elementT.idDiente) {
                        elementT.lstPadecimientos.push({
                          nombrePdx: elementD.nombrePdx,
                        });
                      }
                    });
                  }
                });
              }
            });

            this.hojasCDX = datos;
          }
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.hojasCDX {
  min-height: 200px;
}

.divHojas {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin-top: 10px;
}

#text-button {
  text-align: left;
}

.container-fluid {
  background-color: white !important;
}

.flxHoja {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.flxItmHojaPr {
  width: 90%;
}
.flxItmHojaSc {
  display: flex;
  justify-content: flex-end;
  text-align: left;
  width: 10%;
}
</style>
